import {useEffect, useState} from "react";
import {connect} from "react-redux";

import {getCurrentLayout} from "../../appLayout";
import {getImagePromiseFromLayout} from "../../../misc/getCanvasImageFromLayout";

const WithCanvasImage = (props) => {

  const {children, visualizersLoadedLength} = props;

  const [canvasSrc, setCanvasSrc] = useState("");

  const setCanvasImage = () => {
    const layout = getCurrentLayout();
    getImagePromiseFromLayout(layout)
      .then((response) => setCanvasSrc(response));
  };

  useEffect(() => {
    setCanvasImage()
  }, [visualizersLoadedLength])

  return children(canvasSrc)
};

const mapStateToProps = (store) => {
  return {
    visualizersLoadedLength: store.serverState.visualizersLoaded.length,
  };
};

export default connect(mapStateToProps)(WithCanvasImage)
